import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { registerSW } from 'virtual:pwa-register'
import App from './App'
import './styles/index.css'

// Registro del Service Worker con auto-update.
// `onNeedRefresh` se dispara cuando hay una nueva versión; usamos `updateSW(true)`
// para reemplazar al SW actual y recargar sin preguntar al usuario, porque la app
// es usada en campo desde la pantalla de bloqueo y no debe pedir confirmaciones.
if (typeof window !== 'undefined') {
  const updateSW = registerSW({
    immediate: true,
    onNeedRefresh() {
      updateSW(true)
    },
  })

  // Marca el <body> cuando la app corre como PWA instalada (standalone) para que
  // el CSS pueda aplicar el safe-area padding solo en ese contexto.
  const mq = window.matchMedia('(display-mode: standalone)')
  const applyStandalone = (matches: boolean) => {
    document.body.classList.toggle('pwa-standalone', matches)
  }
  applyStandalone(mq.matches || (navigator as any).standalone === true)
  mq.addEventListener?.('change', (e) => applyStandalone(e.matches))
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
)
